import { render } from "./NewAggregatorModal.vue?vue&type=template&id=6bf50d68&scoped=true&ts=true"
import script from "./NewAggregatorModal.vue?vue&type=script&lang=ts"
export * from "./NewAggregatorModal.vue?vue&type=script&lang=ts"

import "./NewAggregatorModal.vue?vue&type=style&index=0&id=6bf50d68&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf50d68"]])

export default __exports__